import { render, staticRenderFns } from "./main.exp.vue?vue&type=template&id=147db3bf&scoped=true"
import script from "./main.exp.vue?vue&type=script&lang=js"
export * from "./main.exp.vue?vue&type=script&lang=js"
import style0 from "./main.exp.vue?vue&type=style&index=0&id=147db3bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147db3bf",
  null
  
)

export default component.exports